var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.257 4.41a.834.834 0 0 0-1.18 1.179l2.499 2.5a.834.834 0 0 0 1.23-.056l4.167-5a.833.833 0 1 0-1.28-1.067L4.11 6.265 2.257 4.41Z","fill":"currentColor"}));
}

Check.defaultProps = {"width":"10","height":"10","fill":"none"};

module.exports = Check;

Check.default = Check;
